module.exports = __webpack_public_path__ + "img/bangzhu.5afd5320.png";